var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var LinkedinIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 53,
    glyphHeight: 48
  }), React.createElement("path", {
    d: "M12.1784 47.5382H2.12689V15.3732H12.1784V47.5382ZM6.85112 11.3526C6.08067 11.4174 5.30515 11.3218 4.57349 11.0719C3.84182 10.822 3.16989 10.4232 2.60007 9.90062C2.03026 9.37803 1.57494 8.74302 1.26282 8.03565C0.950714 7.32828 0.78859 6.5639 0.786682 5.79073C0.792446 5.00545 0.961495 4.22995 1.28308 3.51351C1.60467 2.79707 2.07177 2.15535 2.6547 1.62914C3.23763 1.10292 3.92365 0.703722 4.66915 0.456891C5.41466 0.21006 6.20336 0.121001 6.98514 0.195371C7.75408 0.135734 8.52705 0.23571 9.25552 0.489017C9.98399 0.742324 10.6522 1.14349 11.2183 1.66734C11.7843 2.19119 12.236 2.8264 12.5448 3.5331C12.8537 4.2398 13.0132 5.00273 13.0132 5.77398C13.0132 6.54523 12.8537 7.30815 12.5448 8.01485C12.236 8.72155 11.7843 9.35677 11.2183 9.88061C10.6522 10.4045 9.98399 10.8056 9.25552 11.0589C8.52705 11.3123 7.75408 11.4122 6.98514 11.3526H6.85112ZM52.7867 47.5382H41.2944V30.7856C41.2944 26.4299 39.4851 23.4815 35.5315 23.4815C34.3186 23.4691 33.133 23.842 32.1455 24.5464C31.1581 25.2509 30.4197 26.2506 30.0367 27.4016C29.7845 28.2597 29.6937 29.1572 29.7686 30.0485V47.4376H18.3769C18.3769 47.4376 18.3769 17.9531 18.3769 15.2727H29.7686V20.332C30.7429 18.5592 32.2121 17.1083 33.997 16.1564C35.7819 15.2044 37.8052 14.7926 39.8202 14.9711C47.0238 14.9711 52.6862 19.5949 52.6862 29.5459L52.7867 47.5382Z"
  }));
};
export var LinkedinIconGlyph = function (props) {
  return React.createElement(LinkedinIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};